import defaultColor from "@/components/color";

export default {
    attribute:{
        borderColor:'#252525',
        pieColor: defaultColor,
        pieColor2: [],
        tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        cptTableData: [{ "name": "维度", "value": "", "namekey": "name" },{ "name": "指标", "value": "", "namekey": "value" }] 
    },
    cptDataForm:{dataText: '[{"value":1048,"name":"搜索引擎"},{"value":735,"name":"直接访问"},{"value":580,"name":"邮件营销"},{"value":484,"name":"联盟广告"},{"value":300,"name":"视频广告"}]',dataSource: 1, pollTime: 0},
}